import request from './request';
// 上传图片
const uploadImg = (formData, callback) => {
  request('/common/upload/image', {
    method: 'POST',
    data: formData,
  })
    .then((res) => {
      callback(res);
    })
    .catch(() => {
      // console.log('💢 => //.error');
    });
};
//下载图片
const downloadImg = (param, callback) => {
  console.log('param', param);
  const arry = param.split('/');
  request(`/common/download/image/${arry[0]}/${arry[1]}`, {
    method: 'GET',
  })
    .then((res) => {
      callback(res);
    })
    .catch(() => {
      // console.log('💢 => //.error');
    });
};
/**
 * 上传文件
 * @param {*} fileUrl 上传接口
 * @param {*} formData 内容
 * @param {*} callback 回调函数
 * @param {*} type 文件类型
 */
const uploadFile = (fileUrl, formData, callback) => {
  request(fileUrl, {
    method: 'POST',
    data: formData,
  })
    .then((res) => {
      callback(res);
    })
    .catch((error) => {
      console.log('💢 => 上传文件时报错', error);
      return callback({ code: '-999' });
    });
};

export { uploadImg, downloadImg, uploadFile };
